export default __webpack_public_path__ + "static/media/AI_hugging.4a23d684.svg";